"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineConfigDescriptionsSimple = void 0;
const convertTimeFormat_1 = require("../convertTimeFormat");
const pluralize_1 = require("../pluralize");
const groupRoomsByTypeAndBoard_1 = require("./groupRoomsByTypeAndBoard");
const getOrderLineConfigDescriptionsSimple = (data, type) => {
    if (!data || !type)
        return null;
    const descriptions = [];
    switch (type) {
        case "GOLF": {
            const config = data;
            const hasCaddies = () => {
                if (config?.product?.config?.caddie) {
                    return true;
                }
                if (config?.caddies?.enabled &&
                    config?.caddies?.payment_option !== "ON_ARRIVAL" &&
                    config?.caddies?.type === "SINGLE_CADDIE") {
                    return true;
                }
                return false;
            };
            const hasSharedCaddies = () => {
                if (config?.product?.config?.shared_caddie) {
                    return true;
                }
                if (config?.caddies?.enabled &&
                    config?.caddies?.payment_option !== "ON_ARRIVAL" &&
                    config?.caddies?.type === "SHARED_CADDIE") {
                    return true;
                }
                return false;
            };
            const hasCarts = () => {
                if (config?.product?.config?.single_cart) {
                    return true;
                }
                if (config?.carts?.enabled &&
                    config?.carts?.payment_option !== "ON_ARRIVAL" &&
                    config?.carts?.types
                        ?.filter((x) => x.type === "SINGLE_CART")
                        ?.find((x) => x.cost_per_cart > 0 && x.quantity > 0)) {
                    return true;
                }
                return false;
            };
            const hasSharedCarts = () => {
                if (config?.product?.config?.shared_cart) {
                    return true;
                }
                if (config?.carts?.enabled &&
                    config?.carts?.payment_option !== "ON_ARRIVAL" &&
                    config?.carts?.types
                        ?.filter((x) => x.type === "SHARED_CART")
                        ?.find((x) => x.cost_per_cart > 0 && x.quantity > 0)) {
                    return true;
                }
                return false;
            };
            let start_times = "";
            if (config.tee_time &&
                config.tee_time.start_time &&
                config.tee_time.end_time) {
                if (config.tee_time.start_time !== config.tee_time.end_time) {
                    start_times = `${(0, convertTimeFormat_1.convertTimeFormat)(config.tee_time.start_time)} - ${(0, convertTimeFormat_1.convertTimeFormat)(config.tee_time.end_time)}`;
                }
                else {
                    start_times = `${(0, convertTimeFormat_1.convertTimeFormat)(config.tee_time.start_time)} (shotgun start)`;
                }
            }
            descriptions.push(`${config?.product?.config?.holes}H ${hasCaddies() ? `+ Caddie ` : ``} ${hasSharedCaddies() ? `+ Shared Caddie ` : ``} ${hasCarts() ? `+ Cart ` : ``} ${hasSharedCarts() ? `+ Shared Cart ` : ``} · ${config.where_when_who?.number_of_golfers} pax ${config?.tee_time?.start_time ? `· ${start_times}` : ``}`);
            break;
        }
        case "HOTEL": {
            const config = data;
            const grouped_rooms = (0, groupRoomsByTypeAndBoard_1.groupRoomsByTypeAndBoard)(config.rooms.rooms);
            grouped_rooms.forEach((room) => {
                let occupancy = room.occupancy;
                if (room.extra_beds > 0) {
                    occupancy += room.extra_beds;
                }
                descriptions.push(`${room.quantity} x ${room.name} ${room.extra_beds > 0
                    ? ` + ${(0, pluralize_1.pluralize)(room.extra_beds, "extra bed", "extra beds")}`
                    : ""} - ${(0, pluralize_1.pluralize)(occupancy, "guest", "guests")}`);
            });
            if (config.where_when_who.hotel.check_in_time) {
                descriptions.push(`Check-in from ${config.where_when_who.hotel.check_in_time}`);
            }
            break;
        }
        case "EXCURSION": {
            const config = data;
            descriptions.push(`${config?.product?.variation?.name?.en} · ${config?.where_when_who.number_of_people} pax`);
            const d = [];
            if (config?.product?.variation?.start_time) {
                d.push(`Start time: ${config?.product?.variation?.start_time}`);
            }
            if (config?.product?.variation?.duration) {
                d.push(`Duration: ${config?.product?.variation?.duration}`);
            }
            // if (config?.product?.variation?.included_meals) {
            //   d.push(`Meals: ${config?.product?.variation?.included_meals}`);
            // }
            descriptions.push(d.join(" · "));
            descriptions.push(`${config?.product?.variation?.hotel_pickup_available
                ? "Includes"
                : "Excludes"} hotel pick-up/drop-off`);
            break;
        }
        case "TRANSFER": {
            const config = data;
            const getPickup = () => {
                switch (config?.transfer_legs?.outbound?.from_type) {
                    case "Hotel":
                    case "Airport": {
                        return `Pick-up time: ${config?.driver?.pickup_time || "TBC"}`;
                    }
                    case "Area": {
                        const area_config = config?.transfer_legs?.outbound
                            ?.from_details;
                        return `Pick-up address: ${area_config?.address || "TBC"} · Pick-up time: ${config?.driver?.pickup_time || "TBC"}`;
                    }
                    case "Course": {
                        return ``;
                    }
                    default: {
                        return "";
                    }
                }
            };
            descriptions.push(`${config?.vehicle?.vehicle?.id
                ? `${config?.vehicle?.quantity > 1
                    ? `${config?.vehicle?.quantity} x `
                    : ``}${config?.vehicle?.vehicle?.name?.en}`
                : `No Vehicle Selected`} · ${config?.where_when_who.number_of_passengers} passengers`);
            if (getPickup() !== "") {
                descriptions.push(getPickup());
            }
            break;
        }
        case "CUSTOM": {
            const config = data;
            config?.where_when_who?.product_description.forEach((description) => {
                descriptions.push(description.title);
            });
            break;
        }
    }
    return descriptions;
};
exports.getOrderLineConfigDescriptionsSimple = getOrderLineConfigDescriptionsSimple;
